<template>
	<inertia-head title="FIRE - Retirement Fund Computation" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						FIRE - Retirement Fund Computation
					</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						FIRE (Financial Independence Retire Early) - Retirement Fund Computation
					</h2>
				</div>
			</div>
		</div>
	</div>

	
	<div class="content">
		<div class="row g-xxl-5 items-push py-4">
			<div class="col-12 mb-6">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="form-group">
							<label>Monthly Expense</label>
							<div class="input-group">
								<input v-model="form.monthly_expense" type="text" name="monthly_expense" class="form-control" title="Monthly Expense"/>
								<span class="input-group-btn">
									<button @click="computeFire" type="button" class="btn btn-info">Compute</button>
								</span>
							</div>
						</div>
						<div class="mt-5">
							<h5>Computation</h5>
							<hr/>
							<div class="form-group mb-4">
								<label>Total Annual Expense</label>
								<div class="form-control">{{moneyFormatter().format(form.annual_expense)}}</div>
							</div>
							<div class="form-group mb-4">
								<label class="fw-bold">Target Retirement Fund</label>
								<div class="form-control">{{moneyFormatter().format(form.target_retire_fund)}}</div>
							</div>
						</div>
						<div class="mt-5">
							<div class="table-responsive">
								<div class="form-group mb-4">
									<label>Estimated Interest/Return Rate</label>
									<select v-model="form.interest_rate_return" name="interest_rate_return" class="form-control">
										<option value="4" selected>4%</option>
										<option value="5">5%</option>
										<option value="6">6%</option>
										<option value="7">7%</option>
										<option value="8">8%</option>
									</select>
								</div>
								<div class="form-group mb-4">
									<label>Retirement years</label>
									<select v-model="form.retirement_year" name="retirement_year" class="form-control">
										<option value="10" selected="">10</option>
										<option value="15">15</option>
										<option value="20">20</option>
										<option value="25">25</option>
										<option value="30">30</option>
										<option value="35">35</option>
										<option value="40">40</option>
									</select>
								</div>
								<table class="table">
									<thead>
										<tr>
											<th>Retirement</th>
											<th>BEGINNING BALANCE</th>
											<th>Less: Withdrawal for the year (4%)</th>
											<th>Remaining Balance</th>
											<th>Add: Estimated Interest/Return ({{form.interest_rate_return}}%)</th>
											<th>Ending Balance</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(retire,t_index) in retirementComputation.data">
											<td>Year {{retire.year}}</td>
											<td>{{moneyFormatter().format(retire.beginning_balance)}}</td>
											<td>{{moneyFormatter().format(retire.yearly_withdrawal)}}</td>
											<td>{{moneyFormatter().format(retire.remaining_balance)}}</td>
											<td>{{moneyFormatter().format(retire.interest_return)}}</td>
											<td>{{moneyFormatter().format(retire.ending_balance)}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import { watch, reactive, ref, onMounted, inject } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'
import { useForm } from '@inertiajs/inertia-vue3';

export default {
	props:{
	
	},
	layout: AuthLayout,
	setup(props) {

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
		
		const year = (new Date()).getFullYear();

		const moneyFormatter = inject('moneyFormatter');

		const form = useForm({
						monthly_expense 		: '',
						annual_expense 			: 0,
						target_retire_fund 		: 0,
						interest_rate_return 	: 4,
						retirement_year 		: 10,
					});

		const retirementComputation = reactive({
			data : []
		});

		const computeFire = ()=>{

			form.annual_expense 		= Math.round(parseFloat(form.monthly_expense)*12);
			form.target_retire_fund 	= Math.round(form.annual_expense*25);
			
			retirementComputation.data 	= [];

			for (var i = 0; i < parseInt(form.retirement_year); i++) {
				retirementComputation.data.push({
					year 				: i+1,
					beginning_balance 	: (i==0) ? form.target_retire_fund : retirementComputation.data[i-1].ending_balance,
					yearly_withdrawal 	: 0,
					remaining_balance 	: 0,
					interest_return 	: 0,
					ending_balance 		: 0
				});

				retirementComputation.data[i].yearly_withdrawal = Math.round(parseFloat(retirementComputation.data[i].beginning_balance)/25);
				retirementComputation.data[i].remaining_balance = Math.round(parseFloat(retirementComputation.data[i].beginning_balance) - retirementComputation.data[i].yearly_withdrawal);
				retirementComputation.data[i].interest_return 	= Math.round(retirementComputation.data[i].remaining_balance * (parseFloat(form.interest_rate_return)/100));
				retirementComputation.data[i].ending_balance 	= Math.round(retirementComputation.data[i].remaining_balance + retirementComputation.data[i].interest_return);

			}
			
		}

		watch(()=>[form.interest_rate_return,form.retirement_year],([value,old_value],[value1,old_value1])=>{
			if(value!=old_value || value1!=old_value1)
			{
				computeFire();
			}
		});
		
		return{
			moneyFormatter,
			form,
			year,
			computeFire,
			retirementComputation
		}
	},
}
</script>
